/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRadarLine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-radar-line_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-radar-line_svg__st0"
      d="M6.8 10.7 9.3 17h5.4l2.5-6.3L12 6.8l-5.2 3.9zm6.5 4.3h-2.6l-1.5-3.7 2.8-2 2.8 2.1-1.5 3.6z"
    />
    <path
      className="ico-chart-radar-line_svg__st0"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    />
  </Icon>
);
export { SvgChartRadarLine as ChartRadarLine };
